import { useState, useEffect } from 'react';
import { useAuth } from '../hooks/useAuth';
import { useParams } from 'react-router';

import AuthLayout from '../components/AuthLayout';

import ThemeLink from '../components/ThemeLink';
import LoadingSpinner from '../components/LoadingSpinner';

export default function VerifySignUp() {
  const { verifysignup } = useAuth();

  const [verified, setVerified] = useState(false);
  const [verifiedEmail, setVerifiedEmail] = useState();
  const [error, setError] = useState();

  const { verificationToken } = useParams();

  useEffect(() => {
    if (verificationToken) {
      verifysignup(verificationToken)
        .then(({ email, verified }) => {
          if (verified) {
            setVerified(true);
            setVerifiedEmail(email);
          }
        })
        .catch((err) => {
          setError(err.message);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [verificationToken]);

  return (
    <AuthLayout>
      {!error && !verified && <LoadingSpinner message="Verifying account..." />}
      {error && <div className="text-error">{error}</div>}
      {!error && verified && (
        <div className="text-center">
          <p className="mb-3 font-light text-3xl">
            Your account has been successfully verified.
          </p>
          <p>
            Please{' '}
            <ThemeLink to="/signin" state={{ email: verifiedEmail }}>
              Sign In.
            </ThemeLink>
          </p>
        </div>
      )}
    </AuthLayout>
  );
}
